import React, { useState, useEffect, useRef } from 'react';
import { Orbis } from '@orbisclub/orbis-sdk';
import { getAddressFromDid } from '@orbisclub/orbis-sdk/utils/index.js';
import makeBlockie from 'ethereum-blockies-base64';

var styles = {"chatBoxContainer":"_F8J7I","flexRow":"_FoQQj","flexColumn":"_3XzrZ","secondary":"_1UvyR","btnBlack":"_2X5nI","chatBoxContainerCta":"_3DjVO","chatBoxContainerExpanded":"_2s91x","chatBoxHead":"_GNUuf","chatBoxMessagesContainer":"_3cSnu","chatBoxInputContainer":"_2hUPP","chatBoxOneMessageContainer":"_31CF9","pfpContainer":"_BvB9W","chatBoxOneMessageContainerSender":"_7Yn9O","chatBoxOneSupportMessage":"_1hBrd","chatBoxOneMessageReplyLine":"_2tsLs","chatBoxOneMessageReply":"_3ZtMF","pfp":"_1O9TM","chatBoxMessageBoxContainer":"_3xx-8","chatBoxSubmitContainer":"_ULg1s","chatBoxSubmit":"_oRU98","chatBoxContactReplyToInfo":"_35sLh","chatBoxContactReplyToInfoLabel":"__5g0M","chatBoxInput":"_3S7ji","hoveredActions":"_19n5W","hoveredAction":"_3Jaqd","loadingSpinner":"_2UFED","spin":"_1rdww"};

let _orbis = new Orbis();

let _theme = {};
function ChatBox({
  orbis,
  context,
  theme,
  poweredByOrbis,
  title = "Ask your questions to our community."
}) {
  if (theme) {
    _theme = theme;
  }

  if (orbis) {
    return /*#__PURE__*/React.createElement(ChatBoxContent, {
      title: title,
      orbis: orbis,
      context: context,
      poweredByOrbis: poweredByOrbis
    });
  } else {
    return /*#__PURE__*/React.createElement(ChatBoxContent, {
      title: title,
      orbis: _orbis,
      context: context,
      poweredByOrbis: poweredByOrbis
    });
  }
}

function ChatBoxContent({
  orbis,
  context,
  poweredByOrbis,
  title
}) {
  const [user, setUser] = useState();
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [replyTo, setReplyTo] = useState();
  const [replyToText, setReplyToText] = useState();

  function reply(message) {
    if (message) {
      setReplyTo(message.stream_id);
      setReplyToText(message.content.body);
    } else {
      setReplyTo(null);
      setReplyToText(null);
    }
  }

  useEffect(() => {
    if (expanded) {
      getIsConnected();
      getSupportChannelMessages();
    }

    async function getIsConnected() {
      let res = await orbis.isConnected();

      if (res && res.status == 200) {
        setUser(res.details);
      }
    }

    async function getSupportChannelMessages() {
      setLoading(true);
      let {
        data,
        error
      } = await orbis.getPosts({
        context: context
      });
      setLoading(false);
      setMessages(data);
    }
  }, [expanded]);

  function PoweredByOrbis() {
    switch (poweredByOrbis) {
      case "black":
        return /*#__PURE__*/React.createElement("a", {
          href: "https://orbis.club",
          target: "_blank",
          rel: "noreferrer"
        }, /*#__PURE__*/React.createElement("img", {
          src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/powered-by-orbis-black.png?t=2022-08-16T15%3A43%3A55.818Z",
          height: "16"
        }));

      case "white":
        return /*#__PURE__*/React.createElement("a", {
          href: "https://orbis.club",
          target: "_blank",
          rel: "noreferrer"
        }, /*#__PURE__*/React.createElement("img", {
          src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/powered-by-orbis-white.png?t=2022-08-16T15%3A44%3A13.487Z",
          height: "16"
        }));

      case null:
        return null;

      default:
        return /*#__PURE__*/React.createElement("a", {
          href: "https://orbis.club",
          target: "_blank",
          rel: "noreferrer"
        }, /*#__PURE__*/React.createElement("img", {
          src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/powered-by-orbis-black.png?t=2022-08-16T15%3A43%3A55.818Z",
          height: "16"
        }));
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxContainerCta,
    style: _theme.mainCta,
    onClick: () => setExpanded(!expanded)
  }, expanded ? /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-close.png?t=2022-08-16T15%3A44%3A35.039Z",
    height: "27"
  }) : /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-message.png?t=2022-08-16T15%3A44%3A44.696Z",
    height: "27"
  })), expanded && /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxContainerExpanded
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxHead,
    style: _theme.header
  }, title != null && /*#__PURE__*/React.createElement("p", null, title), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 5
    }
  }, /*#__PURE__*/React.createElement(PoweredByOrbis, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxMessagesContainer,
    style: _theme.messagesContainer
  }, loading && /*#__PURE__*/React.createElement("p", {
    style: {
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-spinner-black.png?t=2022-08-16T15%3A45%3A06.071Z",
    className: styles.loadingSpinner
  })), /*#__PURE__*/React.createElement(Messages, {
    user: user,
    messages: messages,
    reply: reply,
    replyTo: replyTo
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxInputContainer,
    style: _theme.footer
  }, user ? /*#__PURE__*/React.createElement(MessageBox, {
    orbis: orbis,
    user: user,
    context: context,
    messages: messages,
    setMessages: setMessages,
    reply: reply,
    replyTo: replyTo,
    replyToText: replyToText
  }) : /*#__PURE__*/React.createElement("p", {
    style: {
      width: "100%",
      textAlign: "center",
      margin: 0
    }
  }, /*#__PURE__*/React.createElement(ConnectButton, {
    orbis: orbis,
    user: user,
    setUser: setUser
  })))));
}

function Messages({
  user,
  messages,
  reply,
  replyTo
}) {
  return messages.map((message, key) => {
    return /*#__PURE__*/React.createElement(Message, {
      user: user,
      message: message,
      key: key,
      reply: reply,
      replyTo: replyTo
    });
  });
}

function Message({
  user,
  message,
  reply,
  replyTo
}) {
  const [hoverRef, isHovered] = useHover();
  return /*#__PURE__*/React.createElement("div", {
    ref: hoverRef,
    className: user && message.creator == user.did ? styles.chatBoxOneMessageContainerSender : styles.chatBoxOneMessageContainer
  }, (!user || user == null || user && message.creator != user.did) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: 3
    }
  }, /*#__PURE__*/React.createElement(PfP, {
    did: message.creator,
    details: message.creator_details,
    displayBadge: false
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.flexColumn
  }, message.reply_to && /*#__PURE__*/React.createElement("div", {
    className: styles.flexRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxOneMessageReplyLine,
    style: _theme.replyLine
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxOneMessageReply,
    style: _theme.replyText
  }, message.reply_to_details && message.reply_to_details.body && message.reply_to_details.body.length > 40 ? shortMessage(message.reply_to_details.body, 40) : message.reply_to_details.body)), /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxOneSupportMessage,
    style: user && message.creator == user.did ? _theme.messageSent : _theme.messageReceived
  }, /*#__PURE__*/React.createElement("p", null, message.content.body))), user && message.creator == user.did && /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 3
    }
  }, /*#__PURE__*/React.createElement(PfP, {
    did: message.creator,
    details: message.creator_details,
    displayBadge: false
  })), isHovered && /*#__PURE__*/React.createElement("div", {
    className: styles.hoveredActions
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.hoveredAction,
    onClick: () => reply(message)
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-replyto.png?t=2022-08-16T15%3A45%3A14.642Z",
    height: "15"
  }))), replyTo && replyTo == message.stream_id && /*#__PURE__*/React.createElement("div", {
    className: styles.hoveredActions
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.hoveredAction,
    onClick: () => reply(null)
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-replyto-active.png?t=2022-08-16T15%3A45%3A23.656Z",
    height: "15"
  }))));
}

function MessageBox({
  user,
  orbis,
  context,
  messages,
  setMessages,
  replyTo,
  replyToText,
  reply
}) {
  const [message, setMessage] = useState();
  const [sending, setSending] = useState(false);
  const contactInput = useRef(null);
  useEffect(() => {
    if (replyTo) {
      if (contactInput.current) {
        contactInput.current.focus();
      }
    }
  }, [replyTo]);

  async function sendMessage() {
    if (!message || message == "") {
      alert("You can't share an empty message.");
      return;
    }
    setSending(true);
    let res = await orbis.createPost({
      body: message,
      context: context,
      reply_to: replyTo ? replyTo : null,
      master: replyTo ? replyTo : null
    });
    console.log("res sharing post: ", res);

    if (res.status == 200) {
      setSending(false);
      setMessage("");

      if (contactInput.current) {
        contactInput.current.textContent = "";
        contactInput.current.focus();
      }

      let nMessage = {
        creator: user.did,
        creator_details: {
          did: user.did,
          profile: user.profile
        },
        stream_id: res.doc,
        content: {
          body: message,
          context: context
        },
        master: replyTo ? replyTo : null,
        reply_to: replyTo ? replyTo : null,
        reply_to_details: replyTo ? {
          body: replyToText
        } : null,
        reply_to_creator_details: null
      };
      let _messages = [...messages];
      setMessages([nMessage, ..._messages]);
      reply(null);
    } else {
      alert("Error sharing post.");
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxMessageBoxContainer
  }, replyTo && /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxContactReplyToInfo
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: styles.chatBoxContactReplyToInfoLabel
  }, "Replying to:"), " ", replyToText && replyToText.length > 30 ? shortMessage(replyToText, 30) : replyToText)), /*#__PURE__*/React.createElement("div", {
    className: styles.flexRow,
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: 5,
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(PfP, {
    did: user.did,
    details: user
  })), /*#__PURE__*/React.createElement("input", {
    ref: contactInput,
    className: styles.chatBoxInput,
    style: _theme.input,
    placeholder: "Type your message",
    disabled: sending,
    value: message,
    onChange: e => setMessage(e.target.value)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.chatBoxSubmitContainer
  }, sending ? /*#__PURE__*/React.createElement("button", {
    className: styles.chatBoxSubmit,
    style: _theme && _theme.mainCta ? _theme.mainCta : null
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-spinner-white.png?t=2022-08-16T15%3A44%3A56.022Z",
    className: styles.loadingSpinner
  })) : /*#__PURE__*/React.createElement("button", {
    className: styles.chatBoxSubmit,
    style: _theme && _theme.mainCta ? _theme.mainCta : null,
    onClick: () => sendMessage()
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-send.png?t=2022-08-16T15%3A45%3A33.759Z"
  })))));
}

function ConnectButton({
  orbis,
  user,
  setUser
}) {
  const [loading, setLoading] = useState(false);

  async function connect() {
    setLoading(true);
    let res = await orbis.connect(null, false);

    switch (res.status) {
      case 200:
        setUser(res.details);
        setLoading(false);
        break;

      default:
        console.log("Couldn't connect to Ceramic: ", res.error);
    }
  }

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.btnBlack,
      style: _theme.connectBtn
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://ylgfjdlgyjmdikqavpcj.supabase.co/storage/v1/object/public/orbis-sdk-modules/icons/question-spinner-white.png?t=2022-08-16T15%3A44%3A56.022Z",
      height: "18",
      className: styles.loadingSpinner
    }));
  }

  return /*#__PURE__*/React.createElement("div", null, user ? /*#__PURE__*/React.createElement("div", {
    className: styles.btnBlack,
    style: _theme && _theme.connectBtn ? _theme.connectBtn : null
  }, "Connected") : /*#__PURE__*/React.createElement("div", {
    className: styles.btnBlack,
    style: _theme && _theme.connectBtn ? _theme.connectBtn : null,
    onClick: () => connect()
  }, "Connect"));
}
function PfP({
  did,
  details
}) {
  const {
    address
  } = useDidToAddress(did);

  const PfpImg = () => {
    if (details && details.profile && details.profile.pfp) {
      var _details$profile;

      return /*#__PURE__*/React.createElement("img", {
        src: (_details$profile = details.profile) === null || _details$profile === void 0 ? void 0 : _details$profile.pfp,
        className: styles.pfp
      });
    } else if (address) {
      return /*#__PURE__*/React.createElement("img", {
        src: makeBlockie(address),
        className: styles.pfp
      });
    } else {
      return /*#__PURE__*/React.createElement("img", {
        src: "https://arweave.net/zNxzwq2U7nNZnEosK49drVmOom4nFv89nOlSlbsnczg",
        className: styles.pfp
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.pfpContainer
  }, /*#__PURE__*/React.createElement(PfpImg, null));
}

function shortMessage(text, length) {
  if (!text) {
    return "-";
  }

  const _firstChars = text.substring(0, length);

  return _firstChars + "...";
}

function useDidToAddress(did) {
  let res = getAddressFromDid(did);
  return res;
}
function useHover() {
  const [value, setValue] = useState(false);
  const ref = useRef(null);

  const handleMouseOver = () => setValue(true);

  const handleMouseOut = () => setValue(false);

  useEffect(() => {
    const node = ref.current;

    if (node) {
      node.addEventListener("mouseover", handleMouseOver);
      node.addEventListener("mouseout", handleMouseOut);
      return () => {
        node.removeEventListener("mouseover", handleMouseOver);
        node.removeEventListener("mouseout", handleMouseOut);
      };
    }
  }, [ref.current]);
  return [ref, value];
}

const ExampleComponent = ({
  text
}) => {
  return /*#__PURE__*/React.createElement(ChatBox, null);
};

export { ChatBox, ExampleComponent };
